import { useApolloClient } from "@apollo/client";
import { PushNotificationPayloads } from "@equiem/user-pubsub";
import { useRouter } from "next/router";
import { useMemo } from "react";

export const useRecurringSubscriptionHandler = () => {
  const router = useRouter();
  const { cache } = useApolloClient();

  return useMemo(() => ({
    onClick: async (data: Partial<PushNotificationPayloads.Data.RecurringSubscriptionData>) => {
      await router.push(`/store/current?subscription=${data.subscription}`);
    },
    onMessage: async (_data: Partial<PushNotificationPayloads.Data.RecurringSubscriptionData>) => {
      cache.evict({ fieldName: "activityFeedV2", broadcast: true });
      cache.evict({ fieldName: "customerSubscriptions", broadcast: true });
      cache.gc();
    },
  }), [cache, router]);
};
